import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

export const SkanId1VisaMobile = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState("United States");

  const countries = [
    "United States",
    "Canada",
    "Mexico",
    "Argentina",
    "Brazil",
    "Chile",
    "Colombia",
    "Peru",
    "United Kingdom",
    "Germany",
    "France",
    "Italy",
    "Spain",
    "Portugal",
    "Netherlands",
    "Australia",
    "New Zealand",
    "India",
    "China",
    "Japan",
    "South Korea",
    "South Africa",
    "Egypt",
    "Nigeria",
    "Russia",
    "Ukraine",
    "Poland",
    "Sweden",
    "Norway",
    "Denmark",
    "Finland",
    "Turkey",
    "Saudi Arabia",
    "United Arab Emirates",
    "Pakistan",
    "Bangladesh",
    "Vietnam",
    "Thailand",
    "Philippines",
    "Indonesia",
    "Malaysia",
    "Singapore",
    "Israel",
    "Switzerland",
    "Austria",
    "Belgium",
    "Ireland",
    "Czech Republic",
    "Greece",
    "Hungary",
    "Romania",
    "Slovakia",
    "Croatia",
    "Morocco",
    "Algeria",
    "Kenya",
    "Ethiopia",
  ];

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_skan_id_02-visa-mobile${currentParams}`);
  };

  const styles = {
    telefono: {
      fontFamily: "Open Sans, sans-serif",
      marginTop: "30px",
      backgroundColor: "#f1f1f1",
      display: "flex",
      borderRadius: "50px",
      border: "15px solid #333333",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    arrow: {
      fontSize: "26px",
      marginLeft: "8px",
    },
    containerPhone: {
      width: "100%",
      margin: "0 auto",
      fontFamily: "sans-serif",
      padding: "20px",
    },
    description: {
      fontSize: "15px",
      color: "#333",
      marginBottom: "20px",
      lineHeight: "1.5",
    },
    label: {
      display: "block",
      fontSize: "14px",
      fontWeight: "600",
      marginBottom: "12px",
      color: "#111",
    },

    select: {
      width: "100%",
      padding: "12px",
      fontSize: "16px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      outline: "none",
      backgroundColor: "#fff",
    },
    lines: {
      display: "flex",
      flexDirection: "column",
      marginRight: "8px",
    },
    lineBlue: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.primario,
      marginBottom: "4px",
    },
    lineYellow: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.secundario,
    },
    containerStep: {
      display: "flex",
      alignItems: "baseline",
      fontFamily: "sans-serif",
    },
    current: {
      color: colors.primario,
      fontSize: "40px",
      fontWeight: "bold",
    },
    separator: {
      margin: "0 2px",
      color: "#959699",
      fontSize: "18px",
    },
    total: {
      color: "#959699",
      fontSize: "18px",
    },
    page: {
      fontFamily: "Open Sans, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "30px",
      position: "relative",
      backgroundColor: "#ffffff",
      width: "375px",
      height: "812px",
      overflow: "hidden",
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
    },
    container: {
      display: "flex",
      padding: "16px",
      height: "100%",
      boxSizing: "border-box",
      alignItems: "center",
      margin: "16px 0 8px 0",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
      height: "160px",
      width: "90%",
      borderBottom: "1px solid #E7E7E7",
    },
    title: {
      fontSize: "18px",
      marginBottom: "20px",
      color: "#333",
    },
    checkboxContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      width: "90%",
      marginBottom: "40px",
    },
    checkbox: {
      marginTop: "4px",
      transform: "scale(1.2)",
      accentColor: "#0052cc",
    },

    button: {
      width: "90%",
      padding: "12px",
      height: "54px",
      backgroundColor: colors.primario,
      color: "#fff",
      fontSize: "16px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      position: "absolute",
      bottom: 16,
    },
  };

  return (
      <div style={styles.telefono}>
        <div style={styles.page}>
          <div style={styles.header}>
            <div style={{display: "flex", gap: 12}}>
              {colors.url_logo !== "" ? (
                  <img className="inicio-de-sesion-de-2" src={colors.url_logo}
                       style={{height: 70, maxWidth: 120, objectFit:'contain'}}/>) : (<></>)}
            </div>
            <div style={styles.containerStep}>
              <span style={styles.current}>04</span>
              <span style={styles.separator}> / </span>
              <span style={styles.total}>06</span>
            </div>
          </div>
          <div
              style={{
                ...styles.container,
                width: "100%",
                flexDirection: "column",
                justifyContent: "initial",
                alignItems: "center",
              }}
          >
            <div style={styles.containerPhone}>
              <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="2" y="2" width="60" height="60" rx="12" fill="white"/>
                <circle
                    cx="32"
                    cy="20"
                    r="6"
                    stroke="#333333"
                    strokeWidth="2"
                    fill={colors.primario}
                />
                <path
                    d="M24 32C24 28 28 26 32 26C36 26 40 28 40 32"
                    stroke="#333333"
                    strokeWidth="2"
                />
                <path
                    d="M20 44C20 38 26 36 32 36C38 36 44 38 44 44V48H20V44Z"
                    stroke="#333333"
                    strokeWidth="2"
                    fill={colors.secundario}
                />
                <rect
                    x="10"
                    y="10"
                    width="8"
                    height="8"
                    stroke="#333333"
                    stroke-width="2"
                />
                <rect
                    x="46"
                    y="10"
                    width="8"
                    height="8"
                    stroke="#333333"
                    stroke-width="2"
                />
                <rect
                    x="10"
                    y="46"
                    width="8"
                    height="8"
                    stroke="#333333"
                    stroke-width="2"
                />
                <rect
                    x="46"
                    y="46"
                    width="8"
                    height="8"
                    stroke="#333333"
                    stroke-width="2"
                />
              </svg>
              <p style={styles.description}>
                Scan your ID Card to continue. We’ll use it to verify your
                identity. You’ll be able to use your DNI to resume your
                application if needed.
              </p>
              <label style={styles.label}>Choose your country</label>
              <select
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                  style={styles.select}
              >
                {countries.map((country) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                ))}
              </select>
            </div>
            <button onClick={handleButtonClick} style={styles.button}>
              Next
            </button>
          </div>
        </div>
      </div>
  );
};
